import React, { Component } from 'react';
import WetSlider from './WetSlider.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';

class TapeDelayComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.props.effect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                       effectNumber={this.props.effectNumber}
                       name={'Rate'}
                       parameter={this.props.effect.rateParameter}
                       onParameterChanged={this.props.onParameterChanged}
                       sequencerEngine={this.props.sequencerEngine}
                       isParameter={true}
                       lfoEnabled={true}
                       root={2}
                       step={0.0001}
                       min={0}
                       max={1}
                          />
               
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                         automation={this.props.automation}
                         name='Feedback'
                         lfoEnabled={true}
                         selectedParameter={this.props.selectedParameter}
                         sequencerEngine={this.props.sequencerEngine}
                         unit='%'
                         parameter={this.props.effect.feedbackParameter}
                         onParameterChanged={this.props.onParameterChanged}
                         isParameter={true}
                         displayFunction={(feedback) => Math.floor(feedback*100)}
                         step={0.01}
                         max={1}
                         min={0}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                         automation={this.props.automation}
                         name='Saturation'
                         lfoEnabled={true}
                         selectedParameter={this.props.selectedParameter}
                         sequencerEngine={this.props.sequencerEngine}
                         parameter={this.props.effect.driveParameter}
                         onParameterChanged={this.props.onParameterChanged}
                         isParameter={true}
                         step={0.01}
                         max={6}
                         min={0.1}
                        />
                  <div className="eq-knobs">
                    <ParameterKnob
                      name="Low"
                      min={-16}
                      max={3}
                      parameter={this.props.effect.lowEQParameter}
                      scrollContainer={this.props.scrollContainer}
                    />
                    <ParameterKnob
                      name="Mid"
                      min={-16}
                      max={3}
                      parameter={this.props.effect.midEQParameter}
                      scrollContainer={this.props.scrollContainer}
                    />
                    <ParameterKnob
                      min={-16}
                      max={3}
                      name="Hi"
                      parameter={this.props.effect.highEQParameter}
                      scrollContainer={this.props.scrollContainer}
                    />
                  </div>
                    <WetSlider
                          effectNumber={this.props.effectNumber}
                          sequencerEngine={this.props.sequencerEngine}
                          automation={this.props.automation}
                          selectedParameter={this.props.selectedParameter}
                          onParameterChanged={this.props.onParameterChanged}
                          effect={this.props.effect}/>
                </div>} 
            </div>
        );
    }
}

export default TapeDelayComponent;
